const NAME = "DOCUMENT_PUBLICATION";

export default NAME;